import React from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import RefereeContent from './RefereeContent'
export default class Referee extends React.Component {
    
    render() {
        let id = this.props.match.params.id;
       
        return (
            <div className="wrapper">

                <div className="preloader hide flex-column justify-content-center align-items-center">
                    <img className="animation__shake" src="assets/dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60" />
                </div>
                <Navbar />
                <Mainmenu />
                <RefereeContent id={id} />
                <Footer /> 

            </div>


        )
    }
}
